<template lang="html">
  <div id="d-page-template-1">

    <!-- <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section> -->

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-sm-6 col-title">
          <h2>Capacitaciones</h2>
        </div>
      </div>
    </section>

    <section class="requests-section">
      <div class="box-results">
        <b-card no-body>
          <b-tabs class="tabs-lg" card>

            <!-- Para mi area -->
            <b-tab title="Internas" active>
              <b-card-text>

                <div class="no-gutters post-template-s6" >
                
                    <div class="box-content" v-for="(v, vInx) in rows.internas" :key="'vInx-'+vInx">
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title">{{v.name}}</h6>
                           
                          </div>
                          <div class="col-2 col-info">
                            <h6 class="title">Sesion</h6>
                            <p class="f-w-700">{{v.sesion_custom}}</p>
                          </div>
                          <div class="col-2 col-info">
                            <h6 class="title">Test</h6>
                            <p class="f-w-700">{{v.test_custom}}</p>
                          </div>
                          <div class="col-2 col-info">
                            <h6 class="title">Practiva</h6>
                            <p class="f-w-700">{{v.practice_custom}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
               
              </b-card-text>
            </b-tab>

            <b-tab title="Comercial">
              <b-card-text>

                <div class="no-gutters post-template-s6" >

                    <div class="box-content" v-for="(v, vInx) in rows.comercial" :key="'vInx-'+vInx">
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title">{{v.name}}</h6>
                          
                          </div>
                          <div class="col-3 col-info">
                            <h6 class="title">Estatus</h6>
                            <p class="f-w-700">{{v.status_custom}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-content" >
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title"></h6>
                          
                          </div>
                          <div class="col-3 col-info">
                            <h6 class="title">Total avance</h6>
                            <p class="f-w-700">{{rows.percent_comercial}} %</p>
                          </div>
                        </div>
                      </div>
                    </div>

                </div>

              </b-card-text>
            </b-tab>
            <b-tab title="Operativa">
              <b-card-text>

                <div class="no-gutters post-template-s6" >

                    <div class="box-content" v-for="(v, vInx) in rows.operativa" :key="'vInx-'+vInx">
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title">{{v.name}}</h6>
                          
                          </div>
                          <div class="col-3 col-info">
                            <h6 class="title">Estatus</h6>
                            <p class="f-w-700">{{v.status_custom}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="box-content" >
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title"></h6>
                          
                          </div>
                          <div class="col-3 col-info">
                            <h6 class="title">Total avance</h6>
                            <p class="f-w-700">{{rows.percent_operativa}} %</p>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>

              </b-card-text>
            </b-tab>
            <b-tab title="Técnica">
              <b-card-text>

                <div class="no-gutters post-template-s6" >

                    <div class="box-content" v-for="(v, vInx) in rows.tecnica" :key="'vInx-'+vInx">
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title">{{v.name}}</h6>
                          
                          </div>
                          <div class="col-3 col-info">
                            <h6 class="title">Estatus</h6>
                            <p class="f-w-700">{{v.status_custom}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="box-content" >
                      <div class="box-info-cols">
                        <div class="row _row">
                          <div class="col-6 col-info">
                            <h6 class="title"></h6>
                          
                          </div>
                          <div class="col-3 col-info">
                            <h6 class="title">Total avance</h6>
                            <p class="f-w-700">{{rows.percent_tecnica}} %</p>
                          </div>
                        </div>
                      </div>
                    </div>

                </div>

              </b-card-text>
            </b-tab>
            <!--  -->

            <!-- Extras -->
            <!-- <b-tab title="Extras">
              <b-card-text>
                <router-link class="post-template-s5 w-extra"
                  :to="{ name: 'accCapDetallePage', params: { id: 1 } }">
                  <div class="box-main-content">
                    <div class="box-top">
                      <div class="col col-title">
                        <h5 class="title">Negocios internacionales</h5>
                      </div>

                      <div class="col-12 col-location">
                        <h5 class="f-w-400 subtitle">Impartido por: Alexis Trujillo Cervantes, Psicologo.</h5>
                      </div>
                    </div>

                    <div class="mt-0 box-info">
                      <div class="descr">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="box-extra-content">
                    <div class="box-bubbles">
                      <span class="bubble yellow">En curso</span>
                    </div>

                    <div class="box-txt">
                      <span class="date">12/MAYO/2023</span>
                    </div>
                  </div>
                </router-link>
              </b-card-text>
            </b-tab> -->
            <!--  -->

          </b-tabs>
        </b-card>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },

      rows: [],
      

    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },
    getRows(){
      axios.get(tools.url("/api/trainings")).then((response)=>{
          this.rows = response.data;
          
          
      }).catch(()=>{});
    }
  },
  mounted(){
      this.getRows();
  }
}
</script>
